import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/PartnersSection.tsx");
